export default [
  {
    path: '/sales/retail-orders',
    name: 'sales-retail-orders-index',
    component: () => import('@/views/sales/retail-orders/RetailOrderList.vue'),
    meta: {
      title: 'Retail Orders',
      pageTitle: 'Sales',
      breadcrumb: [
        {
          text: 'Retail Orders',
          active: true,
        },
      ],
      resource: 'RetailOrder',
      action: 'read',
    },
  },
  {
    path: '/sales/retail-orders/:id/register-payment',
    name: 'sales-retail-orders-register-payment',
    component: () => import('@/views/sales/retail-orders/RegisterOrderPayment.vue'),
    meta: {
      title: 'Register Payment',
      pageTitle: 'Sales',
      navActiveLink: 'sales-retail-orders-index',
      breadcrumb: [
        {
          text: 'Retail Orders',
          to: '/sales/retail-orders',
        },
        {
          text: 'Register Payment',
          active: true,
        },
      ],
      resource: 'RetailOrder',
      action: 'update',
    },
  },
  {
    path: '/sales/transactions',
    name: 'sales-transactions-index',
    component: () => import('@/views/sales/transactions/TransactionList.vue'),
    meta: {
      title: 'Transactions',
      pageTitle: 'Sales',
      breadcrumb: [
        {
          text: 'Transactions',
          active: true,
        },
      ],
      resource: 'Transaction',
      action: 'read',
    },
  },
  {
    path: '/sales/sales-submissions/changi',
    name: 'sales-changi-submissions',
    component: () => import('@/views/sales/changi-submission/SubmissionList.vue'),
    meta: {
      title: 'Sales Submissions (Changi)',
      pageTitle: 'Sales',
      breadcrumb: [
        {
          text: 'Sales Submissions (Changi)',
          active: true,
        },
      ],
      resource: 'ChangiSalesSubmission',
      action: 'read',
    },
  },
  {
    path: '/sales/sales-submissions/changi/:id/show',
    name: 'sales-changi-submissions-show',
    component: () => import('@/views/sales/changi-submission/SubmissionDetails.vue'),
    meta: {
      title: 'Submission Detail',
      pageTitle: 'Sales',
      navActiveLink: 'sales-changi-submissions',
      breadcrumb: [
        {
          text: 'Sales Submissions (Changi)',
          to: '/sales/sales-submissions/changi',
        },
        {
          text: 'Submission Detail',
          active: true,
        },
      ],
      resource: 'ChangiSalesSubmission',
      action: 'show',
    },
  },
  {
    path: '/sales/sales-submissions',
    name: 'sales-submissions',
    component: () => import('@/views/sales/submission/SubmissionList.vue'),
    meta: {
      title: 'Submissions & Payments',
      pageTitle: 'Sales',
      breadcrumb: [
        {
          text: 'Submissions & Payments',
          active: true,
        },
      ],
      resource: 'SalesSubmission',
      action: 'read',
    },
  },
  {
    path: '/sales/sales-submissions/:id/show',
    name: 'sales-submissions-show',
    component: () => import('@/views/sales/submission/SubmissionDetails.vue'),
    meta: {
      title: 'Submission Detail',
      pageTitle: 'Sales',
      navActiveLink: 'sales-submissions',
      breadcrumb: [
        {
          text: 'Submissions & Payments',
          to: '/sales/sales-submissions',
        },
        {
          text: 'Submission Detail',
          active: true,
        },
      ],
      resource: 'SalesSubmission',
      action: 'show',
    },
  },
  {
    path: '/sales/sales-submissions/:id/register-payment',
    name: 'sales-submissions-register-payment',
    component: () => import('@/views/sales/submission/RegisterPayment.vue'),
    meta: {
      title: 'Register Payment',
      pageTitle: 'Sales',
      navActiveLink: 'sales-submissions',
      breadcrumb: [
        {
          text: 'Submissions & Payments',
          to: '/sales/sales-submissions',
        },
        {
          text: 'Register Payment',
          active: true,
        },
      ],
      resource: 'SalesSubmission',
      action: 'register-payment',
    },
  },
  {
    path: '/sales/sales-orders',
    name: 'sales-orders',
    component: () => import('@/views/sales/order/SalesOrderList.vue'),
    meta: {
      title: 'Sales Orders',
      pageTitle: 'Sales',
      breadcrumb: [
        {
          text: 'Sales Orders',
          active: true,
        },
      ],
      resource: 'SalesOrder',
      action: 'read',
    },
  },
  {
    // Agent-facing link target for the "SO sent back for edits" email button (and any other
    // agent-email deep link into a Sales Order) - unauthenticated (frontend: true bypasses both
    // the login redirect and the ACL check in router/index.js's beforeEach), since the agent
    // clicking an email link has no admin SPA session. Same component as the authenticated admin
    // route below - it still calls this.$http internally, so it won't show real data without a
    // session; this route's job for now is just giving the email button a real URL to open.
    path: '/agent/sales/sales-orders/:id/show',
    name: 'agent-sales-orders-show',
    component: () => import('@/views/sales/order/SalesOrderDetails.vue'),
    meta: {
      title: 'Sales Order Detail',
      layout: 'full',
      frontend: true,
    },
  },
  {
    path: '/sales/sales-orders/:id/show',
    name: 'sales-orders-show',
    component: () => import('@/views/sales/order/SalesOrderDetails.vue'),
    meta: {
      title: 'Sales Order Detail',
      pageTitle: 'Sales',
      navActiveLink: 'sales-orders',
      breadcrumb: [
        {
          text: 'Sales Orders',
          to: '/sales/sales-orders',
        },
        {
          text: 'Sales Order Detail',
          active: true,
        },
      ],
      resource: 'SalesOrder',
      action: 'show',
    },
  },
]
